import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from "./api";
import auth from "@/utils/auth";
import "./plugins/element.js";
import ElementUI from 'element-ui';
import { pagination } from 'element-ui'
import './assets/style/theme/index.css';
import './assets/fonts/iconfont/iconfont.css';
import "./assets/css/common.css";
import global from './plugins/global';
import 'default-passive-events';
import globalMethod from './common/lang/GlobalMethod'

Vue.component(pagination)

Vue.prototype.$onWait=new Promise((reslove)=>{
  Vue.prototype.$reslove=reslove;
})
// 全局获取缓存数据
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'them') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
},
Vue.prototype.validSe = function (value, number = 255) {
  value = value.replace(/[\W]/g, '').replace(/\s/g, "");
  if (value.length >= number) {
    this.$message({
      type: "warning",
      message: `输入内容不能超过${number}个字符`
    });
  }
  return value;
}

Vue.config.productionTip = false

Vue.prototype.$api = api;
Vue.prototype.$auth = auth;
Vue.prototype.$onWait=new Promise((reslove)=>{
  Vue.prototype.$reslove=reslove;
})
Vue.prototype.$global = global;
Vue.prototype.$fun = globalMethod;
Vue.use(ElementUI)

new Vue({
 beforeCreate() {
    Vue.prototype.$bus = this;
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app');

